import styles from './financial.module.scss';
import {NavLink, Outlet} from 'react-router-dom';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const FINANCIAL_SUBTABS = [
  {
    key: 'revenue-metrics',
    to: '/dashboard/financial/',
    name: 'Revenue Metrics',
  },
  {
    key: 'wallet-metrics',
    to: '/dashboard/financial/wallet',
    name: 'Wallet Metrics',
  },
  {
    key: 'order-metrics',
    to: '/dashboard/financial/orders',
    name: 'Order Metrics',
  },
  {
    key: 'volume-metrics',
    to: '/dashboard/financial/volume',
    name: 'Volume Metrics',
  },
];

/**
 * The Financials shell.
 *
 * The rail is built from NavLink rather than the shared `CustomLink`, whose
 * styles belong to the investor-update screens and are used by several others
 * — restyling it here would have moved them all.
 */
export const FinancialHeader = () => {
  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.Financials,
    FINANCIAL_SUBTABS,
  );

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <h1 className={styles.title}>Revenue KPIs</h1>
        <div className={styles.sub}>
          Revenue, wallet, order and volume figures across every currency.
        </div>
        <nav className={styles.routes}>
          {visibleSubTabs.map(tab => (
            <NavLink
              key={tab.key}
              to={tab.to}
              end
              className={({isActive}) =>
                `${styles.tab} ${isActive ? styles.tabActive : ''}`
              }>
              {tab.name}
            </NavLink>
          ))}
        </nav>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
};
